<section class="discover-events-section" [hidden]="eventList.length === 0">
  <div class="container-fluid container-max">
    <!-- Section Header Row -->
    <div class="events-header-row d-flex justify-content-between align-items-center mb-5 p-lg-0 px-4 px-md-5">
      <h2 class="events-section-title hf mb-0 f80">UPCOMING EVENTS</h2>
      <button class="hero-btn primary text-uppercase f16" (click)="viewAllEvents()">VIEW ALL EVENTS</button>
    </div>

    <!-- Asymmetric Events Grid -->
    <div class="row g-4 align-items-stretch p-lg-0 px-4 px-md-5">
      <!-- Left Column: Giant Featured Card (1st Event) -->
      <div class="col-12 col-lg-8 d-flex" *ngIf="eventList[0]">
        <div class="event-card event-card-featured w-100 position-relative cursor-pointer" (click)="viewEventDetails(eventList[0])">
          <div class="card-bg-wrap">
            <img
              [src]="eventList[0]?.largeImage ? fileDirectoriesPath + eventList[0]?.largeImage : 'assets/images/home/hiwbg.png'"
              alt="Featured Event Image"
              class="card-bg-img"
            />
          </div>

          <!-- Translucent Gradient Overlay -->
          <div class="card-gradient-overlay"></div>

          <!-- Card Elements (Tags + Details) -->
          <div class="card-overlay-elements d-flex flex-column justify-content-between h-100 p-4 p-md-5">
            <!-- Top Sport Tags -->
            <div class="card-top-tags d-flex align-items-center gap-2">
              <span class="sport-tag-badge f16" *ngFor="let sports of eventList[0]?.eventSports ? eventList[0]?.eventSports.slice(0, 1) : []">
                {{ sports?.sport?.name }}
              </span>
              <span
                *ngIf="eventList[0]?.eventSports?.length > 1"
                class="sport-plus-count-badge f16"
                [ngbTooltip]="getTooltipArray(eventList[0]?.eventSports)"
                container="body"
              >
                +{{ eventList[0]?.eventSports?.length - 1 }}
              </span>
            </div>

            <!-- Bottom Content Info -->
            <div class="card-bottom-info">
              <h3 class="featured-card-title hf mb-3 f40">{{ eventList[0]?.title }}</h3>

              <div class="card-meta-details d-flex flex-column flex-md-row gap-3">
                <div class="meta-detail-item d-flex align-items-center gap-2">
                  <div class="meta-icon" [innerHTML]="ICONS.calendarIcon | safeHtml"></div>
                  <span class="meta-text f16">
                    {{ eventList[0]?.dateTime | date: DATE_TIME_FORMAT }} to {{ eventList[0]?.endDateTime | date: DATE_TIME_FORMAT }}
                  </span>
                </div>

                <div class="meta-detail-item d-flex align-items-center gap-2" *ngIf="eventList[0]?.eventLocations?.length > 0">
                  <div class="meta-icon" [innerHTML]="ICONS.locationIcon | safeHtml"></div>
                  <span class="meta-text ellipsis-text f16">
                    {{ eventList[0]?.eventLocations[0]?.address }}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Right Column: Vertical Stack of 2 Smaller Cards (2nd & 3rd Events) -->
      <div class="col-12 col-lg-4 d-flex flex-column gap-4">
        <ng-container *ngFor="let event of eventList.slice(1, 3)">
          <div class="event-card event-card-small flex-grow-1 position-relative cursor-pointer" (click)="viewEventDetails(event)">
            <div class="card-bg-wrap">
              <img
                [src]="event?.largeImage ? fileDirectoriesPath + event?.largeImage : 'assets/images/home/hiwbg.png'"
                alt="Event Image"
                class="card-bg-img"
              />
            </div>

            <!-- Translucent Gradient Overlay -->
            <div class="card-gradient-overlay"></div>

            <!-- Card Elements (Tags + Details) -->
            <div class="card-overlay-elements d-flex flex-column justify-content-between h-100 p-4">
              <!-- Top Sport Tags -->
              <div class="card-top-tags d-flex align-items-center gap-2">
                <span class="sport-tag-badge f16" *ngFor="let sports of event?.eventSports ? event?.eventSports.slice(0, 1) : []">
                  {{ sports?.sport?.name }}
                </span>
                <span
                  *ngIf="event?.eventSports?.length > 1"
                  class="sport-plus-count-badge f16"
                  [ngbTooltip]="getTooltipArray(event?.eventSports)"
                  container="body"
                >
                  +{{ event?.eventSports?.length - 1 }}
                </span>
              </div>

              <!-- Bottom Content Info -->
              <div class="card-bottom-info">
                <h4 class="small-card-title hf mb-3 f40">{{ event?.title }}</h4>

                <div class="card-meta-details d-flex flex-column gap-2">
                  <div class="meta-detail-item d-flex align-items-center gap-2">
                    <div class="meta-icon" [innerHTML]="ICONS.calendarIcon | safeHtml"></div>
                    <span class="meta-text ellipsis-text f16">
                      {{ event?.dateTime | date: DATE_TIME_FORMAT }}
                    </span>
                  </div>

                  <div class="meta-detail-item d-flex align-items-center gap-2" *ngIf="event?.eventLocations?.length > 0">
                    <div class="meta-icon" [innerHTML]="ICONS.locationIcon | safeHtml"></div>
                    <span class="meta-text ellipsis-text f16">
                      {{ event?.eventLocations[0]?.address }}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </ng-container>
      </div>
    </div>
  </div>
</section>
